import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthentificationGuardWithForcedLoginService } from './authentification/authentification-guard-login.service';
import { AutologinComponent } from './authentification/autologin/autologin.component';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    canActivate: [AuthentificationGuardWithForcedLoginService],
    loadChildren: () =>
      import('./dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  { path: 'autologin', component: AutologinComponent, children: [] },
  {
    path: 'template',
    loadChildren: () =>
      import('./template/template.module').then(m => m.TemplateModule),
    data: { preload: true, delay: true },
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./public/register/register.module').then(m => m.RegisterModule),
    data: { preload: true, delay: true },
  },
  {
    path: '',
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
    data: { preload: true, delay: true },
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      // relativeLinkResolution: "legacy",
      // initialNavigation: "disabled",
    }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
